export const COURSE_BEARING_ATTRIBUTE_KEYS = [
  'course_bearing',
  'courseBearing',
  'course',
  'bearing',
  'heading',
  'camera_bearing',
  'camera_heading',
] as const;

export function normalizeBearingDegrees(value: number): number {
  return ((value % 360) + 360) % 360;
}

export function readNumericBearing(value: unknown): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return null;
  }
  return normalizeBearingDegrees(parsed);
}

export function readCourseBearing(
  attributes: Record<string, unknown> | null | undefined,
): number | null {
  if (!attributes) {
    return null;
  }

  for (const key of COURSE_BEARING_ATTRIBUTE_KEYS) {
    const direct = readNumericBearing(attributes[key]);
    if (direct !== null) {
      return direct;
    }

    const upper = readNumericBearing(attributes[key.toUpperCase()]);
    if (upper !== null) {
      return upper;
    }
  }

  return null;
}

/** Geographic bearing in degrees where 0 = north, clockwise positive. */
export function geographicBearingDegrees(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
): number {
  const dx = x2 - x1;
  const dy = y2 - y1;
  const degrees = (Math.atan2(dx, dy) * 180) / Math.PI;
  return normalizeBearingDegrees(degrees);
}

export function angularDifferenceDegrees(a: number, b: number): number {
  const diff = Math.abs(normalizeBearingDegrees(a) - normalizeBearingDegrees(b));
  return Math.min(diff, 360 - diff);
}
